import { localized, t } from '@weavedev/lit-i18next';
import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { PrintProofReviewResult } from '@/api-sdk';

import {
  iconCheckmarkCircleTransparent,
  iconRejectCircle,
} from '@/components/icons';

import { baseStyles, buttonStyles } from '@/styles';

@customElement('fg-print-proof-status-modal-reviewed')
@localized()
export class FgPrintProofStatusModalReviewed extends LitElement {
  @property({ type: String })
  status?: PrintProofReviewResult;

  render() {
    if (!this.status) {
      return null;
    }

    const messageContent = {
      [PrintProofReviewResult.APPROVED]: {
        icon: iconCheckmarkCircleTransparent,
        title: t('content.printProof.printProofApproved'),
        message: t('content.printProof.printProofApprovedText'),
      },
      [PrintProofReviewResult.REJECTED]: {
        icon: iconRejectCircle,
        title: t('content.printProof.printProofRejected'),
        message: t('content.printProof.printProofRejectedText'),
      },
    };

    return html`
      <div class="message ${this.status}">
        ${messageContent[this.status].icon}
        <strong>${messageContent[this.status].title}</strong>
        <p>${messageContent[this.status].message}</p>
      </div>
      <button
        class="button button-cta close-print-proof"
        @click=${() =>
          this.dispatchEvent(new CustomEvent('close-print-proof-dialog'))}
      >
        ${t('actions.closeWindow')}
      </button>
    `;
  }

  static styles = [
    baseStyles,
    buttonStyles,
    css`
      .message {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }

      .message strong {
        text-transform: uppercase;
      }

      :host([part='retail']) .message.approved {
        color: #008405;
      }

      :host([part='wholesale']) .message.approved {
        color: var(--fg-success, var(--fg-fallback-success));
      }

      .message.approved p {
        color: var(--fg-gray--800, var(--fg-fallback-gray--800));
      }

      .message.rejected {
        color: #c01827;
      }

      svg {
        width: 72px;
        height: 72px;
        margin-bottom: 5px;
      }

      strong {
        font-family: var(
          --fg-font-family--brand,
          var(--fg-fallback-font-family--brand)
        );
        font-size: 2rem;
        line-height: 2.8125rem;
      }

      p {
        text-align: center;
      }

      .close-print-proof {
        width: 100%;
        margin-top: 20px;
      }
    `,
  ];
}
